import axios from "axios";
import store from "../store";

class Agenda {
	getAll() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/agenda/", {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	get(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/agenda/" + id, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	now(id, job) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/agenda/now/" + id,
					{
						job,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	update(id, job) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/agenda/" + id,
					{
						job,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	delete(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.delete(`${process.env.VUE_APP_SAAS_BACK}` + "/agenda/" + id, {
					headers: {
						Authorization: "bearer " + jwt,
					},
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Agenda();
